export interface IGeoLocation {
  loc_id: string;
  geo_location: string;
  geo_lat: string;
  geo_long: string;
  erf_number: string;
}

export interface ProjectFormData  {
  name: string;
  short_name: string;
  desc: string;
  priority_id: string;
  // location_id: number | string;
  district_id: number | string;
  municipality_id: number | string;
  sector_id: number | string;
  department_id: number | string;
  project_owner: number | string;
  project_manager: number | string;
  project_lead: number | string;
};

export interface IProject {
  project_id: string;
  name: string;
  sector_name: string;
  project_manager?: string;
  project_owner?: string;
  project_status: string;
  current_stage?: string;
  desc?: string;
  // location_name?: string;
  
  district_name?: string;
  municipality_name?: string;

  sector_id?: string;
  project_start_date?: string | null;
  project_end_date?: string | null;
  eval_start_date?: string | null;
  eval_end_date?: string | null;
  priority?: string;
  eval_status?: string;
  panoptic_score?: string;
  is_active?: string;
  department_name?: string;
  current_stage_status?: string | null;
  progress?: number;
  locations: IGeoLocation[];
  stages?: IProjectStage[];
  elevatorPitch?: string;
  executiveSummary?: string;
  score?: number;
  updated?: string;
  budget?: number | string;
  can_view_details?: boolean;
  current_stage_id?: string;
  is_test_project?: boolean;
}
export interface IProjectStage {
  dk_stage: string;
  dk_stage_status: string;
  dn_stage: string;
  dn_stage_status: string;
  active_gate: number;
  dn_stage_modified?: string;
  project_stage_id: string;
  doc_file_path?: string;
  project_report?: string;
  send_to_approval?: string;
  doc_name?: string;
  doc2_file_path?: string;
  doc2_name?: string;
  active_step?: number | string;
  is_project_plan_accessible?: number;
  additional_check?: string;
  report_documents?: Record<string, any>;

}
export interface ISortProject {
  project_id: string;
  name: string;
  department_name: string;
  sector_id: number;
  sector_name: string;
  province_id: number | null;
  district_id: number | null;
  district_name: string;
  municipality_id: number | null;
  municipality_name: string;
  location_name: string;
  implementation_timeframe: string;
  implementation_timeframe_name: string;
  idms_project_stage: string;
  idms_project_stage_name: string;
  manager_name?: string;
  sector_priority_term?: string;
}

export interface IProjectRequest {
  project_id: string;
  name: string;
  department_name: string;
  project_manager: string;
  project_stage: string;
  project_stage_id: string;
  project_stage_status: string;
  sector_name: string;
  dk_stage: string;
}

export interface ICreateProjectPipelineList {
  row_id: string;
  project_id: string;
  name: string;
  additional_check_name: string;
  additional_check_datakey: string;
  stage_name: string;
  stage_id: string;
  status: string;
  sector_name: string;
  department_name: string;
  location_name: string;
  project_manager_name: string;
}

export interface IMyProjectList {
  project_id: string;
  name: string;
  priority: string;
  eval_status: string;
  sector_name: string;
  location: string;
  district_name:string;
  municipality_name:string
}

export interface IUpdateAdditionalCheckStatus {
  approval_status: "yes" | "no" | "";
  remarks?: string;
}

export interface IPrioritiseProjectsList {
  row_id: string;
  project_id: string;
  name: string;
  additional_check_name: string;
  additional_check_datakey: string;
  stage_name: string;
  stage_id: string;
  status: string;
  sector_name: string;
  department_name: string;
  location_name: string;
  project_manager_name: string;
}

export interface Stagestep {
  key: string;
  title: string;
  components?: React.ComponentType<any>;
  showIndex: boolean;
  submenu?: Stagestep[];
  icon?: React.ReactNode;
  iconColor?: string;
  iconBackground?: string;
  description?: string;
  tooltip?: string;
  isAllowNextStep?: boolean;
  showContinue?: boolean;
}

export interface CurrentStageStep {
  index: number;
  subIndex: number;
  step: Stagestep;
  isFirst: boolean;
  isLast: boolean;
}

export enum StatusType {
  Q = "acceptance_criteria_risk_for_budget_1",
  R = "acceptance_criteria_risk_for_budget_2",
  X = "acceptance_criteria_risk_for_budget_3",
}

export type StatusValue = StatusType | string;

export type RuleOperator =
  | ">"
  | "<"
  | ">="
  | "<="
  | "=="
  | "!="
  | "between"
  | "in"
  | "contains";

export interface RiskRule {
  operator: RuleOperator;
  value: number | string | number[] | string[];
}

export type RiskConfig = Record<string, RiskRule>;

export interface IGeoLocationList {
  loc_id: string;
  geo_location: string;
  geo_lat: number;
  geo_long: number;
  erf_number: string;
  project_name: string;
  project_index: number;
  budget: string | number;
  sector_name?: string;
}

export interface IProjectEvaluator {
  user_id: number;
  first_name: string;
  last_name: string;
  initials: string;
  eval_status: string;
  reminder_sent: number;
  avg_score?: number;
}

export interface IProjectEvaluationListData {
  project_id: number;
  project_name: string;
  project_eval_status_key: string;
  project_eval_status: string;
  priority: string;
  location: string;
  eval_due_date: string;
  evaluators: IProjectEvaluator[];
  total_reminder_sent: number;
  can_send_reminder: boolean;
}

export enum EvaluationStatusFilter {
  all = "all",
  pending = "pending",
  overdue = "overdue",
  completed = "completed"
}

export interface IProjectEvaluatorData {
  user_id: number;
  full_name: string;
  email: string;
  first_name: string;
  last_name: string;
  initials: string;
  assigned: number;
  done: number;
  pending: number;
  overdue: number;
  reminder_sent: number;
}

export interface IEvaluatorProjects {
  project_id: number;
  project_name: string;
  reminder_count: number;
  eval_status: string;
  reminder_sent: number;
}

export interface INotificationHistory {
  id: number;
  user_id: number;
  full_name: string;
  email: string;
  creation_date: string;
}

export interface ILocationData {
  loc_id?: number;
  geo_location: string;
  erf_number: string;
  geo_lat: number | null;
  geo_long: number | null;
}

export interface IRiskCategory {
  id: number;
  category_name: string;
  description: string;
  is_active: string;
}

export interface IProjectLocationData extends IGeoLocation {
  project_id: string;
  project_name: string;
  budget: string | number;
  sector_name?: string;
}
export interface IProjectTeam {
  user_id: number;
  role_id: string;
  project_rights: string;
  fullname?: string;
  email?: string;
  new?: boolean;
}